import { createReducer } from '@reduxjs/toolkit'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  hasUnreadMessage: false,
}

export type State = typeof INITIAL_STATE

export default createReducer(INITIAL_STATE, {
  [types.UPDATE_HAS_UNREAD_MESSAGE]: (state, action) => {
    state.hasUnreadMessage = action.payload
  },
})
